import { loadView } from '@/router'

export default [
  {
    path: 'credits',
    name: 'billing-credits',
    component: loadView('Application/Billing/Credits'),
    showInAlfred: true,
    alfredTitle: 'Billing - Credits'
  }
]
